/* eslint-disable react/no-danger */
import { ReactElement } from 'react';
import Modal from 'react-modal';

import styles from './Modal.module.scss';

interface iProps {
  show: boolean;
  content: string | ReactElement;
  contentClass?: string;
  close?: () => void;
  shouldCloseOnOverlayClick?: boolean;
}

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const VFSimpleModalWithoutTitle = ({ show, content, close = () => '', contentClass = '', shouldCloseOnOverlayClick = true }: iProps): ReactElement => {
  if (!show) {
    return <></>;
  }

  const rendercontent = (): ReactElement => {
    if (typeof content === 'string') {
      return <div className={styles.body} dangerouslySetInnerHTML={{ __html: content }} />;
    }
    return <div className={styles.body}>{content}</div>;
  };

  return (
    <>
      <Modal isOpen={show} overlayClassName={styles.overlay} className={styles.modalWithoutTitle} onRequestClose={close} contentLabel="Title Model" shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}>
        <div className={`${styles.contentSimpleWithoutTitle} ${contentClass}`}>
          {rendercontent()}
        </div>
      </Modal>
    </>
  );
};

export default VFSimpleModalWithoutTitle;
